import { createSelector } from "@reduxjs/toolkit";

// const fileUploadSelector = createSelector(
//     [state => state.userAuth],
//     (userAuth) => {
//         return userAuth
//     }
// )

// const fileUploadSelect = state => ({
//     userAuth: state.primaryAgencyApplication.application,
// })

export const fileUploadSelect = createSelector(
  (state) => state.primaryAgencyApplication?.application,
  (state) => state.additionalApplications,
  (agencyApp, additionalApps) => {
     return {primaryAgencyApplication:agencyApp,additionalApplications: additionalApps};
  }
);

export default fileUploadSelect;
